import { NimbuxHotelMedia } from "@bandido/shared/interfaces";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Checkbox, Box } from "@mui/material";

type ImageTileBaseProps = {
  img: NimbuxHotelMedia;
  selectable: boolean;
  selected: boolean;
  onToggle: () => void;
  renderBadge?: (img: NimbuxHotelMedia) => React.ReactNode | null;
};

export const ImageTile = (props: ImageTileBaseProps) => {
  const { img, selectable, selected, onToggle, renderBadge } = props;
  
  const badge = renderBadge?.(img);
  
  return (
    <Box sx={{ 
      position: "relative", 
      borderRadius: 1, 
      overflow: "hidden",
      width: '100%',
      aspectRatio: '1 / 1' // Mantiene proporción cuadrada
    }}>
      {badge && (
        <Box sx={{ position: "absolute", left: 30, top: 8, zIndex: 2 }}>
          {badge}
        </Box>
      )}
      <img
        src={img.url}
        alt={img.type || ""}
        loading="lazy"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          display: "block",
          borderRadius: 8,
          outline: selected ? "3px solid #1976d2" : "none",
          transition: "transform .15s ease, outline-color .15s ease",
        }}
      />
      {selectable && (
        <Box sx={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          background: "linear-gradient(to top, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0) 60%)",
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'flex-end',
          p: 1
        }}>
          <Checkbox
            checked={selected}
            onChange={onToggle}
            sx={{
              color: "white",
              "&.Mui-checked": { color: "white" },
            }}
          />
        </Box>
      )}
    </Box>
  );
}

export const SortableImageTile = (props: ImageTileBaseProps) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: props.img.order || 0,
  });

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.8 : 1,
    cursor: "grab",
    width: '100%',
    height: 'auto'
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <ImageTile {...props} />
    </div>
  );
}